<template>
  <b-button
    v-if="show"
    variant="outline-light"
    size="sm"
    :block="showCollapseButtonText"
    @click="$emit('input', !collapsed)"
  >
    {{ buttonText }}{{ collapsed ? '&#9660;' : '&#9650;' }}
  </b-button>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  show: Boolean,
  showCollapseButtonText: Boolean,
  collapsed: Boolean,
  collapseButtonText: {
    type: String,
    default: '',
  },
}

@Component({
  model: {
    prop: 'collapsed',
  },
})
export default class ExpandTableButton extends Vue.extend({ props }) {
  get buttonText () {
    return this.showCollapseButtonText ? this.collapseButtonText + ' ' : ''
  }
}

</script>
